import { IconeCadenas } from '../partage/icones';
import { DEPLACER_LES_BULLES } from '../partage/vocabulaire';
import './Cadenas.css';

/**
 * Le cadenas du bord droit de la Carte, sous la flèche de « Lier » (chantier deplacer-les-bulles,
 * ticket 03, choix A d'Igor du 2026-10-23 : le cadenas dit si on peut déplacer). Fermé, rien ne
 * change ; ouvert, glisser une bulle la déplace (`useGlisserUneBulle`). Dessiné comme le bouton de
 * « Lier » ; la feuille le tient fermé à chaque ouverture d'une feuille et à chaque retour sur la Carte.
 */
export function Cadenas({ ouvert, onBasculer }: { ouvert: boolean; onBasculer: () => void }) {
  return (
    <button
      type="button"
      className="cadenas-flottant"
      aria-pressed={ouvert}
      title={DEPLACER_LES_BULLES}
      aria-label={DEPLACER_LES_BULLES}
      data-ouvert={ouvert ? 'oui' : 'non'}
      onClick={onBasculer}
    >
      <IconeCadenas className="cadenas-icone" ouvert={ouvert} />
    </button>
  );
}
